module.exports = __webpack_public_path__ + "static/don26-f821dd7526d55029d0afbc0dc366f40e.jpg";